/**
 * Centralized debug logging utility
 * Automatically filters logs based on environment
 */

/**
 * Debug logger that only outputs in development
 * @param {string} message - Log message
 * @param {any} data - Optional data to log
 * @param {string} level - Log level: 'log', 'warn', 'error'
 */
export const debugLog = (message, data = null, level = 'log') => {
  if (process.env.NODE_ENV === 'development') {
    if (data !== null) {
      console[level](message, data);
    } else {
      console[level](message);
    }
  }
};

/**
 * Warning logger - shows in development only
 */
export const debugWarn = (message, data = null) => {
  debugLog(message, data, 'warn');
};

/**
 * Error logger - always shows (production needs error logs)
 */
export const debugError = (message, data = null) => {
  console.error(message, data);
};

/**
 * Performance logger for timing operations
 */
export const debugTime = (label) => {
  if (process.env.NODE_ENV === 'development') {
    console.time(label);
  }
};

export const debugTimeEnd = (label) => {
  if (process.env.NODE_ENV === 'development') {
    console.timeEnd(label);
  }
};

/**
 * API request logger with consistent formatting
 */
export const debugAPI = (method, url, data = null) => {
  if (process.env.NODE_ENV === 'development') {
    const message = `[API ${method.toUpperCase()}] ${url}`;
    if (data) {
      console.log(message, data);
    } else {
      console.log(message);
    }
  }
};

/**
 * Component lifecycle logger
 */
export const debugComponent = (componentName, action, data = null) => {
  if (process.env.NODE_ENV === 'development') {
    const message = `[${componentName}] ${action}`;
    if (data) {
      console.log(message, data);
    } else {
      console.log(message);
    }
  }
};